import React from "react";
import { COLORS, FONT, RADIUS } from "./theme";

/**
 * Tooltip dos gráficos.
 *
 * O tooltip do recharts é uma caixa branca com borda cinza e a lista de séries
 * colorida — inclusive o TEXTO na cor da série, que fica ilegível nos tons
 * claros. Aqui a cor fica num ponto ao lado e o texto usa tinta normal.
 *
 * O tooltip nunca é a única forma de ler um valor: os rankings têm rótulo
 * direto na ponta da barra e todos os blocos têm a tabela equivalente abaixo.
 */
export default function ChartTooltip({ active, payload, label, labelSuffix = "" }) {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: COLORS.surface,
        border: `1px solid ${COLORS.border}`,
        borderRadius: RADIUS - 6,
        boxShadow: "0 6px 20px rgba(14, 32, 24, 0.12)",
        padding: "9px 12px",
        fontFamily: FONT,
        minWidth: 120,
      }}
    >
      <div
        style={{
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: "0.04em",
          textTransform: "uppercase",
          color: COLORS.inkMuted,
          marginBottom: 6,
        }}
      >
        {label}
        {labelSuffix}
      </div>
      {payload.map((item) => (
        <div
          key={item.dataKey}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontSize: 13,
            color: COLORS.ink,
            lineHeight: "20px",
          }}
        >
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: item.color || item.fill,
              flexShrink: 0,
            }}
          />
          <span style={{ color: COLORS.inkSecondary }}>{item.name}</span>
          <strong style={{ marginLeft: "auto", fontWeight: 600 }}>{item.value}</strong>
        </div>
      ))}
    </div>
  );
}
